module.exports = __webpack_public_path__ + "media/application/images/contact-img-0a699edd71ddce2eb5b6f55ef21bc060.jpg";